(() => {
  'use strict';
  if (window.__SUNHAUK_B1G2_V10__) return;
  window.__SUNHAUK_B1G2_V10__ = true;
  const B1G2 = {
    root: null,
eyebrow: null,
message: null,
progressFill: null,
progressCount: null,
continueLabel: null,
progressTrack: null,
cartCountEl: null,
toastDuration: 3000,
toastHideTimer: null,
toastHideTransitionTimer: null,
toastVisibleUntil: 0,
slots: [],
    firstTarget: 3,
    secondTarget: 6,
    maxPairs: 6,
    collectionUrl: '/collections/best-sellers',
    roundAttribute: '_sunhauk_b1g2_round',
    roundBridgeKey: 'sunhauk_b1g2_round2_pending',
    excludedHandles: new Set([
      'shipping-protection',
      'mystery-polarized-pair',
      'hard-case-3-pack'
    ]),
    cart: null,
    eligibleCount: 0,
    snapshot: new Map(),
    displayUnits: [],
    initialized: false,
    round2Active: false,
    syncTimer: null,
    syncChain: Promise.resolve(),
    pendingReason: 'external',
    suppressNextAutomaticOpen: false,
    suppressUntil: 0,
    nativeFetch: null,
    popup: null,
    popupDialog: null,
    popupProducts: [],
    popupUpsellCandidates: [],
    popupUpsellsWrap: null,
    popupOpen: false,
popupRound: 1,
popupBaseDealTotal: 0,
popupPairCount: 3,
popupCurrency: null,
popupHideTimer: null,
    completionOpening: false,
    lastFocusedElement: null,
    init() {
      this.root =
        document.querySelector(
          '[data-sunhauk-b1g2]'
        );
      if (!this.root) {
        return;
      }
      this.eyebrow =
        this.root.querySelector(
          '[data-b1g2-eyebrow]'
        );
      this.message =
  this.root.querySelector(
    '[data-b1g2-message]'
  );
this.progressTrack =
  this.root.querySelector(
    '[data-b1g2-progress]'
  );
this.progressFill =
  this.root.querySelector(
    '[data-b1g2-progress-fill]'
  );
this.progressCount =
  this.root.querySelector(
    '[data-b1g2-progress-count]'
  );
this.continueLabel =
  this.root.querySelector(
    '[data-b1g2-continue-label]'
  );
this.cartCountEl =
  this.root.querySelector(
    '[data-b1g2-cart-count]'
  );
this.toastDuration =
  Math.max(
    1000,
    Number(
      this.root.dataset.autoHide ||
      3000
    )
  );
this.slots =
  Array.from(
    this.root.querySelectorAll(
      '[data-b1g2-slot]'
    )
  );
      this.collectionUrl =
        this.root.dataset.collectionUrl ||
        '/collections/best-sellers';
      this.cachePopup();
      this.bindBarClicks();
      this.bindTransientDismissal();
      this.bindPopupEvents();
      this.observeFetch();
      this.observeXHR();
      this.bindThemeEvents();
      this.patchCartDrawer();
      this.queueSync(
        'initial',
        0
      );
    },
    cachePopup() {
      this.popup =
        document.querySelector(
          '[data-b1g2-complete-popup]'
        );
      if (!this.popup) {
        return;
      }
      this.popupDialog =
        this.popup.querySelector(
          '[data-b1g2-popup-dialog]'
        );
      this.popupProducts =
        Array.from(
          this.popup.querySelectorAll(
            '[data-b1g2-popup-product]'
          )
        );
      this.popupUpsellCandidates =
        Array.from(
          this.popup.querySelectorAll(
            '[data-b1g2-popup-upsell]'
          )
        );
      this.popupUpsellsWrap =
        this.popup.querySelector(
          '[data-b1g2-popup-upsells]'
        );
    },
    getStageTarget() {
      return this.round2Active
        ? this.secondTarget
        : this.firstTarget;
    },
    isEligible(item) {
      if (!item) {
        return false;
      }
      const handle =
        String(
          item.handle ||
          item.product_handle ||
          item.product?.handle ||
          ''
        )
          .toLowerCase()
          .trim();
      if (
        this.excludedHandles.has(
          handle
        )
      ) {
        return false;
      }
      const properties =
        item.properties ||
        {};
      if (
        String(
          properties._b1g2_exclude ||
          ''
        ).toLowerCase() === 'true'
      ) {
        return false;
      }
      if (
        properties._rx_bundle &&
        String(
          properties._rx_configured ||
          ''
        ) !== 'true'
      ) {
        return false;
      }
      const type =
        String(
          item.product_type ||
          item.product?.type ||
          item.type ||
          ''
        )
          .toLowerCase()
          .trim();
      if (!type) {
        return false;
      }
      if (
        type.includes('case') ||
        type.includes('sleeve') ||
        type.includes('accessor') ||
        type.includes('hard case')
      ) {
        return false;
      }
      return (
        type.includes('sunglass') ||
        type.includes('sunglas') ||
        type.includes('eyeglass') ||
        type.includes('glasses') ||
        type.includes('frame')
      );
    },
    getImage(item) {
      if (!item) {
        return '';
      }
      return (
        item.featured_image?.url ||
        item.featured_image?.src ||
        (
          typeof item.image === 'string'
            ? item.image
            : ''
        ) ||
        item.image?.src ||
        item.image?.url ||
        ''
      );
    },
    signature(item) {
      const variantId =
        item?.variant_id ||
        item?.id ||
        '';
      if (variantId) {
        return `variant:${variantId}`;
      }
      return (
        `product:${item?.product_id || ''}:` +
        `${item?.handle || item?.product_handle || ''}`
      );
    },
    makeUnit(item) {
      return {
        signature:
          this.signature(
            item
          ),
        variantId:
          item.variant_id ||
          item.id ||
          '',
        productId:
          item.product_id ||
          '',
        title:
          item.product_title ||
          item.title ||
          '',
        variantTitle:
          item.variant_title ||
          '',
       productType:
  item.product_type ||
  '',
vendor:
  item.vendor ||
  item.product?.vendor ||
  '',
image:
  this.getImage(
    item
  ),
        originalPrice:
          Number(
            item.original_price ??
            item.price ??
            item.final_price ??
            0
          ),
        finalPrice:
          Number(
            item.final_price ??
            item.price ??
            item.original_price ??
            0
          ),
        item:
          item
      };
    },
    eligibleItems(cart) {
      return (
        cart?.items ||
        []
      ).filter(
        (item) =>
          this.isEligible(
            item
          )
      );
    },
    countEligible(items) {
      return (
        items ||
        []
      ).reduce(
        (
          total,
          item
        ) => {
          return (
            total +
            Math.max(
              0,
              Number(
                item.quantity ||
                0
              )
            )
          );
        },
        0
      );
    },
    makeSnapshot(items) {
      const map =
        new Map();
      (
        items ||
        []
      ).forEach(
        (item) => {
          const signature =
            this.signature(
              item
            );
          const quantity =
            Math.max(
              0,
              Number(
                item.quantity ||
                0
              )
            );
          map.set(
            signature,
            (
              map.get(
                signature
              ) ||
              0
            ) +
            quantity
          );
        }
      );
      return map;
    },
    getAddedUnits(
      previousSnapshot,
      currentItems
    ) {
      const totals =
        new Map();
      const representative =
        new Map();
      const added =
        [];
      currentItems.forEach(
        (item) => {
          const signature =
            this.signature(
              item
            );
          const quantity =
            Math.max(
              0,
              Number(
                item.quantity ||
                0
              )
            );
          totals.set(
            signature,
            (
              totals.get(
                signature
              ) ||
              0
            ) +
            quantity
          );
          if (
            !representative.has(
              signature
            )
          ) {
            representative.set(
              signature,
              item
            );
          }
        }
      );
      totals.forEach(
        (
          currentQuantity,
          signature
        ) => {
          const previousQuantity =
            previousSnapshot.get(
              signature
            ) ||
            0;
          const difference =
            Math.max(
              0,
              currentQuantity -
              previousQuantity
            );
          const item =
            representative.get(
              signature
            );
          for (
            let i = 0;
            i < difference;
            i += 1
          ) {
            added.push(
              this.makeUnit(
                item
              )
            );
          }
        }
      );
      return added;
    },
    buildPool(items) {
      const pool =
        new Map();
      items.forEach(
        (item) => {
          const signature =
            this.signature(
              item
            );
          const quantity =
            Math.max(
              0,
              Number(
                item.quantity ||
                0
              )
            );
          const list =
            pool.get(
              signature
            ) ||
            [];
          for (
            let i = 0;
            i < quantity;
            i += 1
          ) {
            list.push(
              this.makeUnit(
                item
              )
            );
          }
          pool.set(
            signature,
            list
          );
        }
      );
      return pool;
    },


    /* =========================================================
   ORDER ONE BUY-1-GET-2 GROUP

   The paid pair must always be first.

   INCOMPLETE GROUP:
   Shopify may not have applied the promotion yet,
   so use the current pre-discount selling price.

   COMPLETE GROUP:
   If Shopify has actually returned:
   1 paid + 2 free
   use that real final_price allocation.

   Equal-price products retain their previous order.
   ========================================================= */

orderDealGroup(units) {

  const rows =
    (units || [])
      .filter(Boolean)
      .map(
        (
          unit,
          index
        ) => ({
          unit,
          index
        })
      );


  if (
    rows.length <= 1
  ) {
    return rows.map(
      (row) =>
        row.unit
    );
  }


  /*
    Check whether Shopify has already
    actually applied the B1G2 discount.

    A completed 3-pair group should contain:
    - 1 paid line
    - 2 lines with finalPrice === 0
  */
  const freeRows =
    rows.filter(
      (row) =>
        Number(
          row.unit.finalPrice ||
          0
        ) === 0
    );


  const paidRows =
    rows.filter(
      (row) =>
        Number(
          row.unit.finalPrice ||
          0
        ) > 0
    );


  /*
    COMPLETE GROUP:

    Trust Shopify's real discount allocation
    once we can clearly identify 2 free pairs.
  */
  if (
    rows.length === 3 &&
    freeRows.length === 2 &&
    paidRows.length === 1
  ) {

    return [
      paidRows[0].unit,

      ...freeRows
        .sort(
          (
            a,
            b
          ) => {

            const priceDifference =
              Number(
                b.unit.originalPrice ||
                0
              ) -
              Number(
                a.unit.originalPrice ||
                0
              );


            if (
              priceDifference !== 0
            ) {
              return priceDifference;
            }


            return (
              a.index -
              b.index
            );

          }
        )
        .map(
          (row) =>
            row.unit
        )
    ];

  }


  /*
    INCOMPLETE GROUP:

    Shopify has not necessarily applied the
    promotion yet.

    Predict the paid/free structure using
    the actual current selling price:

    highest price = paid
    lower prices = free candidates
  */
  return rows

    .sort(
      (
        a,
        b
      ) => {

        const priceDifference =
          Number(
            b.unit.originalPrice ||
            0
          ) -
          Number(
            a.unit.originalPrice ||
            0
          );


        if (
          priceDifference !== 0
        ) {
          return priceDifference;
        }


        /*
          Same price:
          do NOT unnecessarily rearrange
          the products.
        */
        return (
          a.index -
          b.index
        );

      }
    )

    .map(
      (row) =>
        row.unit
    );

},



/* =========================================================
   ORDER ALL SIX DISPLAY UNITS

   Round 1:
   positions 1–3 are one B1G2 group.

   Round 2:
   positions 4–6 are another independent group.

   We NEVER mix the two groups here.
   ========================================================= */

orderDisplayUnitsForDeal(units) {

  const safeUnits =
    units ||
    [];


  const firstDeal =
    this.orderDealGroup(
      safeUnits.slice(
        0,
        3
      )
    );


  const secondDeal =
    this.orderDealGroup(
      safeUnits.slice(
        3,
        6
      )
    );


  return [
    ...firstDeal,
    ...secondDeal
  ];

},



    reconcileDisplay(
      items,
      addedUnits = []
     ) {
      const pool =
        this.buildPool(
          items
        );
      const next =
        [];
      this.displayUnits.forEach(
        (oldUnit) => {
          if (
            next.length >=
            this.maxPairs
          ) {
            return;
          }
          const list =
            pool.get(
              oldUnit.signature
            );
          if (
            !list ||
            !list.length
          ) {
            return;
          }
          next.push(
            list.shift()
          );
        }
      );
      addedUnits.forEach(
        (newUnit) => {
          if (
            next.length >=
            this.maxPairs
          ) {
            return;
          }
          const list =
            pool.get(
              newUnit.signature
            );
          if (
            !list ||
            !list.length
          ) {
            return;
          }
          next.push(
            list.shift()
          );
        }
      );
      for (
        const list
        of pool.values()
      ) {
        while (
          list.length &&
          next.length <
            this.maxPairs
        ) {
          next.push(
            list.shift()
          );
        }
        if (
          next.length >=
          this.maxPairs
        ) {
          break;
        }
      }
        return this.orderDisplayUnitsForDeal(
         next
        );
    },


    setRound2Bridge() {
      try {
        sessionStorage.setItem(
          this.roundBridgeKey,
          '1'
        );
      } catch (error) {}
    },
    hasRound2Bridge() {
      try {
        return (
          sessionStorage.getItem(
            this.roundBridgeKey
          ) === '1'
        );
      } catch (error) {
        return false;
      }
    },
    clearRound2Bridge() {
      try {
        sessionStorage.removeItem(
          this.roundBridgeKey
        );
      } catch (error) {}
    },
    getCartRoundMarker(cart) {
      return (
        String(
          cart?.attributes?.[
            this.roundAttribute
          ] ||
          ''
        ).trim() === '2'
      );
    },
    async setCartRoundMarker(value) {
      const fetcher =
        this.nativeFetch ||
        window.fetch.bind(
          window
        );
      try {
        const response =
          await fetcher(
            '/cart/update.js',
            {
              method:
                'POST',
              credentials:
                'same-origin',
              keepalive:
                true,
              headers: {
                'Content-Type':
                  'application/json',
                Accept:
                  'application/json'
              },
              body:
                JSON.stringify({
                  attributes: {
                    [
                      this.roundAttribute
                    ]:
                      value
                        ? String(
                            value
                          )
                        : ''
                  }
                })
            }
          );
        if (
          !response.ok
        ) {
          throw new Error(
            `B1G2 round state failed: ${response.status}`
          );
        }
        return (
          await response.json()
        );
      }
      catch (error) {
        console.error(
          '[Sunhauk B1G2] Could not update six-pair state:',
          error
        );
        return null;
      }
    },
    clearRound2Persistence() {
      this.setCartRoundMarker(
        ''
      );
    },
    bindBarClicks() {
      this.root.addEventListener(
        'click',
        (event) => {
          const close =
            event.target.closest(
              '[data-b1g2-toast-close]'
            );
          if (close) {
            event.preventDefault();
            event.stopPropagation();
            this.hide();
            return;
          }
          const copy =
            event.target.closest(
              '[data-b1g2-open-cart]'
            );
          if (copy) {
            event.preventDefault();
            this.openDrawer(
              copy
            );
            return;
          }
          const slot =
            event.target.closest(
              '[data-b1g2-slot]'
            );
          if (!slot) {
            return;
          }
          event.preventDefault();
          if (
            slot.classList.contains(
              'is-filled'
            )
          ) {
            this.openDrawer(
              slot
            );
          }
          else {
            window.location.assign(
              this.collectionUrl
            );
          }
        }
      );
    },
    bindTransientDismissal() {
      document.addEventListener(
        'pointerdown',
        (event) => {
          if (
            !this.isToastActive()
          ) {
            return;
          }
          if (
            this.root.contains(
              event.target
            )
          ) {
            return;
          }
          this.hide();
        },
        true
      );
      document.addEventListener(
        'keydown',
        (event) => {
          if (
            event.key === 'Escape' &&
            this.isToastActive() &&
            !this.popupOpen
          ) {
            this.hide();
          }
        }
      );
      const reposition =
        () => {
          if (
            this.isToastActive()
          ) {
            this.positionToast();
          }
        };
      window.addEventListener(
        'resize',
        reposition,
        {
          passive: true
        }
      );
      window.addEventListener(
        'scroll',
        reposition,
        {
          passive: true
        }
      );
    },
    positionToast() {

  if (
    !this.root
  ) {
    return;
  }


  /* =======================================================
     1. FIND BOTTOM OF CURRENT VISIBLE HEADER

     Keep panel below whichever header/header-wrapper
     is actually visible right now.
     ======================================================= */

  const selectors = [
    'sticky-header',
    '#shopify-section-header',
    '.section-header',
    '.header-wrapper',
    'header.header'
  ];


  let headerBottom =
    0;


  selectors.forEach(
    (selector) => {

      const element =
        document.querySelector(
          selector
        );


      if (
        !element
      ) {
        return;
      }


      const rect =
        element.getBoundingClientRect();


      if (
        rect.height <= 0 ||
        rect.bottom <= 0 ||
        rect.top >= window.innerHeight ||
        rect.bottom >
          Math.min(
            window.innerHeight * .65,
            420
          )
      ) {
        return;
      }


      headerBottom =
        Math.max(
          headerBottom,
          rect.bottom
        );

    }
  );


  /*
    Mobile reference:
    keep the panel visually attached to the header.

    Desktop keeps the existing 10px spacing so this visual
    adjustment stays scoped to the mobile cart-style panel.
  */
  const mobilePanel =
    window.innerWidth <= 749;


  const headerGap =
    mobilePanel
      ? 1
      : 10;


/* =======================================================
   PANEL TOP POSITION

   MOBILE:
   Keep the existing dynamic header calculation.

   DESKTOP:
   Use the exact position required by the Sunhauk header.
   ======================================================= */

const calculatedTop =
  Math.max(
    mobilePanel
      ? 0
      : 10,
    Math.round(
      headerBottom +
      (
        headerBottom > 0
          ? headerGap
          : 0
      )
    )
  );


const finalTop =
  mobilePanel
    ? calculatedTop
    : 128;


this.root.style.setProperty(
  '--sh-b1g2-toast-top',
  `${finalTop}px`
);


  /* =======================================================
     2. ALIGN POINTER WITH REAL CART ICON

     Dawn / Sunhauk cart icon normally uses
     #cart-icon-bubble.

     Extra selectors are included as fallbacks.
     ======================================================= */

  const cartIcon =
    document.querySelector(
      '#cart-icon-bubble'
    ) ||
    document.querySelector(
      '.header__icon--cart'
    ) ||
    document.querySelector(
      '[data-cart-icon]'
    );


  if (
    !cartIcon
  ) {
    return;
  }


  const cartRect =
    cartIcon.getBoundingClientRect();


  if (
    cartRect.width <= 0 ||
    cartRect.height <= 0
  ) {
    return;
  }


  /*
    Get the center of the real cart icon
    relative to the viewport.
  */
  const cartCenterX =
    cartRect.left +
    (
      cartRect.width /
      2
    );


  /*
    Our toast is aligned from the RIGHT.

    Example mobile:
    right: 6px

    So calculate how far the cart center
    is from the right edge of the toast.
  */
  const rootStyles =
    window.getComputedStyle(
      this.root
    );


  let panelRight =
    parseFloat(
      rootStyles.right
    );


  if (
    Number.isNaN(
      panelRight
    )
  ) {
    panelRight =
      0;
  }


  let panelWidth =
    parseFloat(
      rootStyles.width
    );


  if (
    Number.isNaN(
      panelWidth
    ) ||
    panelWidth <= 0
  ) {

    panelWidth =
      window.innerWidth *
      .60;

  }


  /*
    Mobile only:
    the clickable Dawn cart target is a little wider than the
    visible cart glyph on Sunhauk. Nudge the pointer slightly
    RIGHT so the triangle visually lines up with the icon.

    Desktop keeps the current calculated alignment unchanged.
  */
  const arrowVisualNudge =
    mobilePanel
      ? 9
      : 0;


  let arrowRight =
    window.innerWidth -
    cartCenterX -
    panelRight -
    arrowVisualNudge;


  /*
    Prevent the triangle from ever touching
    the extreme left/right rounded corners.
  */
  const minimumArrowSpace =
    18;


  const maximumArrowSpace =
    Math.max(
      minimumArrowSpace,
      panelWidth -
      minimumArrowSpace
    );


  arrowRight =
    Math.max(
      minimumArrowSpace,
      Math.min(
        arrowRight,
        maximumArrowSpace
      )
    );


/* =======================================================
   ARROW POSITION

   MOBILE:
   Keep dynamically following the real cart icon.

   DESKTOP:
   Use the exact visual alignment required.
   ======================================================= */

const finalArrowRight =
  mobilePanel
    ? arrowRight
    : 28;


this.root.style.setProperty(
  '--sh-b1g2-arrow-right',
  `${Math.round(
    finalArrowRight
  )}px`
);

},
    isToastActive() {
      return Boolean(
        this.root &&
        !this.root.hidden &&
        this.toastVisibleUntil >
          Date.now()
      );
    },
    bindPopupEvents() {
      if (!this.popup) {
        return;
      }
      this.popup.addEventListener(
  'click',
  (event) => {
    const close =
      event.target.closest(
        '[data-b1g2-popup-close]'
      );
    if (close) {
      event.preventDefault();
      this.closePopup();
      return;
    }
    const editSelections =
      event.target.closest(
        '[data-b1g2-edit-selections]'
      );
    if (editSelections) {
      event.preventDefault();
      this.openDrawer(
        editSelections
      );
      return;
    }
    const addMore =
      event.target.closest(
        '[data-b1g2-add-more]'
      );
          if (addMore) {
            event.preventDefault();
            this.activateRound2(
              addMore
            );
            return;
          }
          const upsellAdd =
            event.target.closest(
              '[data-b1g2-popup-upsell-add]'
            );
          if (upsellAdd) {
            event.preventDefault();
            this.addPopupUpsell(
              upsellAdd
            );
            return;
          }
          const upsellRemove =
            event.target.closest(
              '[data-b1g2-popup-upsell-remove]'
            );
          if (upsellRemove) {
            event.preventDefault();
            this.removePopupUpsell(
              upsellRemove
            );
          }
        }
      );
      document.addEventListener(
        'keydown',
        (event) => {
          if (
            event.key === 'Escape' &&
            this.popupOpen
          ) {
            this.closePopup();
          }
        }
      );
    },
    activateRound2(button) {
      if (
        button.dataset.loading ===
        'true'
      ) {
        return;
      }
      button.dataset.loading =
        'true';
      button.setAttribute(
        'aria-busy',
        'true'
      );
      this.round2Active =
        true;
      this.setRound2Bridge();
      this.setCartRoundMarker(
        '2'
      ).then(
        (updatedCart) => {
          if (updatedCart) {
            this.clearRound2Bridge();
          }
        }
      );
      this.closePopup(
        false
      );
      window.location.assign(
        this.collectionUrl
      );
    },
    getPath(input) {
      try {
        if (
          typeof input ===
          'string'
        ) {
          return (
            new URL(
              input,
              location.origin
            ).pathname
          );
        }
        if (
          input instanceof URL
        ) {
          return input.pathname;
        }
        if (
          input?.url
        ) {
          return (
            new URL(
              input.url,
              location.origin
            ).pathname
          );
        }
      }
      catch (error) {}
      return '';
    },
    mutationKind(path) {
      if (
        /\/cart\/add(?:\.js)?$/
          .test(
            path
          )
      ) {
        return 'add';
      }
      if (
        /\/cart\/change(?:\.js)?$/
          .test(
            path
          )
      ) {
        return 'change';
      }
      if (
        /\/cart\/update(?:\.js)?$/
          .test(
            path
          )
      ) {
        return 'update';
      }
      if (
        /\/cart\/clear(?:\.js)?$/
          .test(
            path
          )
      ) {
        return 'clear';
      }
      return '';
    },
    responseItems(payload) {
      if (!payload) {
        return [];
      }
      if (
        Array.isArray(
          payload.items
        )
      ) {
        return payload.items;
      }
      if (
        payload.id ||
        payload.variant_id ||
        payload.product_id
      ) {
        return [
          payload
        ];
      }
      return [];
    },
    responseHasEligible(payload) {
      return (
        this.responseItems(
          payload
        ).some(
          (item) =>
            this.isEligible(
              item
            )
        )
      );
    },
    shouldSuppressAutoDrawer(payload) {
      if (
        !this.responseHasEligible(
          payload
        )
      ) {
        return false;
      }
      return (
        this.eligibleCount <
        this.getStageTarget()
      );
    },
    observeFetch() {
      if (
        window.fetch
          .__sunhaukB1G2V10Observed
      ) {
        return;
      }
      const controller =
        this;
      const originalFetch =
        window.fetch;
      this.nativeFetch =
        originalFetch.bind(
          window
        );
      async function wrappedFetch(
        ...args
      ) {
        const kind =
          controller.mutationKind(
            controller.getPath(
              args[0]
            )
          );
        const response =
          await originalFetch.apply(
            this,
            args
          );
        if (
          !kind ||
          !response.ok
        ) {
          return response;
        }
        let payload =
          null;
        if (
          kind === 'add'
        ) {
          try {
            payload =
              await response
                .clone()
                .json();
          }
          catch (error) {}
          if (
            controller
              .shouldSuppressAutoDrawer(
                payload
              )
          ) {
            controller
              .armDrawerSuppression();
          }
        }
        controller.onMutation(
          kind
        );
        return response;
      }
      wrappedFetch
        .__sunhaukB1G2V10Observed =
        true;
      wrappedFetch
        .__sunhaukB1G2Original =
        originalFetch;
      window.fetch =
        wrappedFetch;
    },
    observeXHR() {
      const proto =
        window.XMLHttpRequest
          ?.prototype;
      if (
        !proto ||
        proto
          .__sunhaukB1G2V10Observed
      ) {
        return;
      }
      const controller =
        this;
      const originalOpen =
        proto.open;
      const originalSend =
        proto.send;
      proto.open =
        function(
          method,
          url,
          ...rest
        ) {
          try {
            this.__sunhaukB1G2Path =
              new URL(
                url,
                location.origin
              ).pathname;
          }
          catch (error) {
            this.__sunhaukB1G2Path =
              '';
          }
          return (
            originalOpen.call(
              this,
              method,
              url,
              ...rest
            )
          );
        };
      proto.send =
        function(
          ...args
        ) {
          const kind =
            controller.mutationKind(
              this.__sunhaukB1G2Path ||
              ''
            );
          if (kind) {
            this.addEventListener(
              'load',
              () => {
                if (
                  this.status < 200 ||
                  this.status >= 300
                ) {
                  return;
                }
                let payload =
                  null;
                if (
                  kind === 'add'
                ) {
                  try {
                    payload =
                      JSON.parse(
                        this.responseText ||
                        'null'
                      );
                  }
                  catch (error) {}
                  if (
                    controller
                      .shouldSuppressAutoDrawer(
                        payload
                      )
                  ) {
                    controller
                      .armDrawerSuppression();
                  }
                }
                controller.onMutation(
                  kind
                );
              },
              {
                once:
                  true
              }
            );
          }
          return (
            originalSend.apply(
              this,
              args
            )
          );
        };
      proto
        .__sunhaukB1G2V10Observed =
        true;
    },
    onMutation(kind) {
      if (
        window.SunhaukCartSync &&
        typeof window
          .SunhaukCartSync
          .refresh ===
        'function'
      ) {
        setTimeout(
          () => {
            window
              .SunhaukCartSync
              .refresh({
                source:
                  `b1g2-${kind}`
              });
          },
          20
        );
      }
      this.queueSync(
        kind === 'add'
          ? 'add'
          : 'external',
        35
      );
    },
    bindThemeEvents() {
      document.addEventListener(
        'sunhauk:cart:changed',
        () => {
          this.queueSync(
            'external',
            80
          );
        }
      );
      document.addEventListener(
        'sunhauk:cart-surfaces-refreshed',
        () => {
          this.queueSync(
            'external',
            25
          );
        }
      );
      document.addEventListener(
        'cart:updated',
        () => {
          this.queueSync(
            'external',
            45
          );
        }
      );
      if (
        typeof window.subscribe ===
          'function' &&
        window
          .PUB_SUB_EVENTS
          ?.cartUpdate
      ) {
        window.subscribe(
          window
            .PUB_SUB_EVENTS
            .cartUpdate,
          () => {
            this.queueSync(
              'external',
              80
            );
          }
        );
      }
      window.addEventListener(
        'pageshow',
        () => {
          this.queueSync(
            'external',
            0
          );
        }
      );
      document.addEventListener(
        'visibilitychange',
        () => {
          if (
            !document.hidden
          ) {
            this.queueSync(
              'external',
              35
            );
          }
        }
      );
    },
    patchCartDrawer() {
      if (
        !customElements
          ?.whenDefined
      ) {
        return;
      }
      customElements
        .whenDefined(
          'cart-drawer'
        )
        .then(
          () => {
            const Drawer =
              customElements.get(
                'cart-drawer'
              );
            if (
              !Drawer
                ?.prototype ||
              Drawer.prototype
                .__sunhaukB1G2V10Patched
            ) {
              return;
            }
            const originalOpen =
              Drawer.prototype.open;
            if (
              typeof originalOpen !==
              'function'
            ) {
              return;
            }
            const controller =
              this;
            Drawer.prototype.open =
              function(
                triggeredBy,
                ...rest
              ) {
                const manual =
                  Boolean(
                    triggeredBy
                  ) ||
                  controller.root
                    ?.dataset
                    .manualOpen ===
                  'true';
                if (manual) {
                  controller
                    .clearDrawerSuppression();
                  if (
                    controller.popupOpen
                  ) {
                    controller
                      .closePopup(
                        false
                      );
                  }
                  return (
                    originalOpen.call(
                      this,
                      triggeredBy,
                      ...rest
                    )
                  );
                }
                if (
                  controller
                    .consumeDrawerSuppression()
                ) {
                  return;
                }
                return (
                  originalOpen.call(
                    this,
                    triggeredBy,
                    ...rest
                  )
                );
              };
            Drawer.prototype
              .__sunhaukB1G2V10Patched =
              true;
          }
        );
    },
    armDrawerSuppression() {
      if (
        this.eligibleCount >=
        this.getStageTarget()
      ) {
        this.clearDrawerSuppression();
        return;
      }
      this.suppressNextAutomaticOpen =
        true;
      this.suppressUntil =
        Date.now() +
        5000;
    },
    clearDrawerSuppression() {
      this.suppressNextAutomaticOpen =
        false;
      this.suppressUntil =
        0;
    },
    consumeDrawerSuppression() {
      if (
        !this.suppressNextAutomaticOpen
      ) {
        return false;
      }
      if (
        Date.now() >
        this.suppressUntil
      ) {
        this.clearDrawerSuppression();
        return false;
      }
      this.clearDrawerSuppression();
      return true;
    },
    async openDrawer(trigger) {
      this.clearDrawerSuppression();
      this.hideImmediately();
      if (
        this.popupOpen
      ) {
        this.closePopup(
          false
        );
      }
      try {
        if (
          window.SunhaukCartSync &&
          typeof window
            .SunhaukCartSync
            .refreshNow ===
          'function'
        ) {
          await window
            .SunhaukCartSync
            .refreshNow({
              source:
                'b1g2-open-cart'
            });
        }
      }
      catch (error) {
        console.warn(
          '[Sunhauk B1G2] drawer refresh failed',
          error
        );
      }
      const drawer =
        document.querySelector(
          'cart-drawer.cart-drawer-v2'
        ) ||
        document.querySelector(
          'cart-drawer'
        );
      if (
        !drawer ||
        typeof drawer.open !==
        'function'
      ) {
        location.assign(
          window.routes
            ?.cart_url ||
          '/cart'
        );
        return;
      }
      this.root.dataset.manualOpen =
        'true';
      try {
        drawer.open(
          trigger ||
          this.root
        );
      }
      finally {
        delete this.root
          .dataset
          .manualOpen;
      }
    },
    queueSync(
      reason = 'external',
      delay = 50
    ) {
      if (
        reason === 'add'
      ) {
        this.pendingReason =
          'add';
      }
      else if (
        this.pendingReason !==
        'add'
      ) {
        this.pendingReason =
          reason;
      }
      clearTimeout(
        this.syncTimer
      );
      this.syncTimer =
        setTimeout(
          () => {
            const reasonToRun =
              this.pendingReason;
            this.pendingReason =
              'external';
            this.syncChain =
              this.syncChain
                .then(
                  () =>
                    this.syncFromCart(
                      reasonToRun
                    )
                )
                .catch(
                  (error) => {
                    console.error(
                      '[Sunhauk B1G2] sync failed',
                      error
                    );
                  }
                );
          },
          delay
        );
    },
    async readCart() {
      const response =
        await fetch(
          '/cart.js',
          {
            credentials:
              'same-origin',
            headers: {
              Accept:
                'application/json'
            },
            cache:
              'no-store'
          }
        );
      if (
        !response.ok
      ) {
        throw new Error(
          `Cart read failed: ${response.status}`
        );
      }
      return response.json();
    },
    shouldShowSticky() {
      if (
        this.round2Active
      ) {
        return (
          this.eligibleCount >=
            this.firstTarget &&
          this.eligibleCount <
            this.secondTarget
        );
      }
      return (
        this.eligibleCount > 0 &&
        this.eligibleCount <
          this.firstTarget
      );
    },
    async syncFromCart(reason) {
      const previousCount =
        this.eligibleCount;
      const previousSnapshot =
        new Map(
          this.snapshot
        );
      const cart =
        await this.readCart();
      const items =
        this.eligibleItems(
          cart
        );
      const currentCount =
        this.countEligible(
          items
        );
      const currentSnapshot =
        this.makeSnapshot(
          items
        );
      let markedRound2 =
        this.getCartRoundMarker(
          cart
        );
      const bridgedRound2 =
        this.hasRound2Bridge();
      if (
        markedRound2
      ) {
        this.clearRound2Bridge();
      }
      else if (
        bridgedRound2 &&
        currentCount >=
          this.firstTarget
      ) {
        markedRound2 =
          true;
        this.setCartRoundMarker(
          '2'
        ).then(
          (updatedCart) => {
            if (updatedCart) {
              this.clearRound2Bridge();
            }
          }
        );
      }
this.cart =
  cart;
const returnedToThreeFromRound2 =
  markedRound2 &&
  previousCount >
    this.firstTarget &&
  currentCount ===
    this.firstTarget;
if (
  returnedToThreeFromRound2
) {
  markedRound2 =
    false;
  this.round2Active =
    false;
  this.clearRound2Persistence();
  this.clearRound2Bridge();
}
if (
  markedRound2 &&
  currentCount <
    this.firstTarget
) {
        markedRound2 =
          false;
        this.round2Active =
          false;
        this.clearRound2Persistence();
        this.clearRound2Bridge();
      }
      if (
        !this.initialized
      ) {
        this.initialized =
          true;
        this.round2Active =
          markedRound2;
        this.eligibleCount =
          currentCount;
        this.snapshot =
          currentSnapshot;
        this.displayUnits =
          this.reconcileDisplay(
            items
          );
        this.render();
        this.hideImmediately();
        return;
      }
      this.round2Active =
        markedRound2;
      const addedUnits =
        this.getAddedUnits(
          previousSnapshot,
          items
        );
      this.eligibleCount =
        currentCount;
      this.snapshot =
        currentSnapshot;
      this.displayUnits =
        this.reconcileDisplay(
          items,
          addedUnits
        );
      const realAdd =
        addedUnits.length > 0 &&
        currentCount >
          previousCount;
if (
  this.popupOpen
) {
  const popupTarget =
    this.popupRound === 2
      ? this.secondTarget
      : this.firstTarget;
  const popupStillValid =
    currentCount >=
    popupTarget;
  if (
    popupStillValid
  ) {
    this.updatePopupUpsellState(
      cart
    );
    return;
  }
  this.closePopup(
    false
  );
}
if (
  returnedToThreeFromRound2
) {
  this.render();
  this.startCompletionFlow(
    cart,
    1
  );
  return;
}
      if (
        !this.round2Active &&
        currentCount <
          this.firstTarget
      ) {
        this.render();
        if (
          realAdd &&
          currentCount > 0
        ) {
          this.show();
        }
        else if (
          !this.isToastActive()
        ) {
          this.hideImmediately();
        }
        return;
      }
      if (
        !this.round2Active &&
        realAdd &&
        previousCount <
          this.firstTarget &&
        currentCount >=
          this.firstTarget
      ) {
        this.render();
        this.startCompletionFlow(
          cart,
          1
        );
        return;
      }
      if (
        this.round2Active &&
        currentCount >=
          this.firstTarget &&
        currentCount <
          this.secondTarget
      ) {
        this.render();
        if (
          realAdd
        ) {
          this.show();
        }
        else if (
          !this.isToastActive()
        ) {
          this.hideImmediately();
        }
        return;
      }
      if (
        this.round2Active &&
        realAdd &&
        previousCount <
          this.secondTarget &&
        currentCount >=
          this.secondTarget
      ) {
        this.render();
        this.startCompletionFlow(
          cart,
          2
        );
        return;
      }
      if (
        this.round2Active &&
        currentCount >=
          this.secondTarget
      ) {
        this.render();
        this.hideImmediately();
        return;
      }
      this.render();
      this.hideImmediately();
    },
    render() {
      this.root
        .classList
        .toggle(
          'is-round-two',
          this.round2Active
        );
      document
        .documentElement
        .classList
        .toggle(
          'sunhauk-b1g2-round-two',
          this.round2Active
        );
      if (
        this.eyebrow
      ) {
        this.eyebrow.textContent =
          this.round2Active
            ? 'DOUBLE OFFER'
            : 'BUY 1 GET 2 FREE';
      }
      if (
        this.cartCountEl
      ) {
        this.cartCountEl.textContent =
          String(
            Math.max(
              0,
              Number(
                this.eligibleCount ||
                0
              )
            )
          );
      }
      this.slots.forEach(
        (
          slot,
          index
        ) => {
          const pairNumber =
            index +
            1;
          const unit =
            this.displayUnits[
              index
            ];


/*
  Deal structure:

  Round 1
  Pair 1 = PAID
  Pair 2 = FREE
  Pair 3 = FREE

  Round 2
  Pair 4 = PAID
  Pair 5 = FREE
  Pair 6 = FREE

  Because displayUnits has already been reordered,
  the highest-priced pair automatically occupies
  the paid position.
*/
const isFreeSlot =
  pairNumber === 2 ||
  pairNumber === 3 ||
  pairNumber === 5 ||
  pairNumber === 6;


slot.classList.toggle(
  'is-free-slot',
  isFreeSlot
);


slot.classList.toggle(
  'is-paid-slot',
  !isFreeSlot
);



          const image =
            slot.querySelector(
              '[data-b1g2-slot-image]'
            );
          const pairLabel =
            slot.querySelector(
              '.sunhauk-b1g2__pair-label'
            );
          if (
            pairLabel
          ) {
            pairLabel.textContent =
              `Pair ${pairNumber}`;
          }
          if (
            unit
          ) {
            slot
              .classList
              .add(
                'is-filled'
              );
            slot.setAttribute(
              'aria-label',
              `Pair ${pairNumber}: ${unit.title}`
            );
            if (
              image
            ) {
              image.src =
                unit.image ||
                '';
              image.alt =
                unit.title ||
                '';
            }
          }
          else {
            slot
              .classList
              .remove(
                'is-filled'
              );
            slot.setAttribute(
              'aria-label',
              `Choose Pair ${pairNumber}`
            );
            if (
              image
            ) {
              image.removeAttribute(
                'src'
              );
              image.alt =
                '';
            }
          }
        }
      );
      this.updateMessage();
      this.updateProgress();
    },
updateMessage() {
  if (
    !this.message
  ) {
    return;
  }

  let headlineMessage = '';
  let actionMessage = '';

  /*
    The compact headline mirrors the final design:
    BUY 1 GET 2 FREE • CHOOSE 2 MORE

    The green CTA keeps the full promotional wording.
  */
  if (
    this.round2Active
  ) {
    if (
      this.eligibleCount === 3
    ) {
      headlineMessage =
        'CHOOSE 3 MORE';

      actionMessage =
        'CHOOSE 3 MORE PAIRS';
    }
    else if (
      this.eligibleCount === 4
    ) {
      headlineMessage =
        'CHOOSE 2 MORE';

      actionMessage =
        'CHOOSE 2 MORE FREE PAIRS';
    }
    else if (
      this.eligibleCount === 5
    ) {
      headlineMessage =
        'CHOOSE 1 MORE';

      actionMessage =
        'CHOOSE 1 MORE FREE PAIR';
    }
    else {
      headlineMessage =
        'DEAL COMPLETE';

      actionMessage =
        'DEAL COMPLETE';
    }
  }
  else {
    const remaining =
      Math.max(
        0,
        this.firstTarget -
          this.eligibleCount
      );

    if (
      remaining > 1
    ) {
      headlineMessage =
        `CHOOSE ${remaining} MORE`;

      actionMessage =
        `CHOOSE ${remaining} MORE FREE PAIRS`;
    }
    else if (
      remaining === 1
    ) {
      headlineMessage =
        'CHOOSE 1 MORE';

      actionMessage =
        'CHOOSE 1 MORE FREE PAIR';
    }
    else {
      headlineMessage =
        'DEAL COMPLETE';

      actionMessage =
        'DEAL COMPLETE';
    }
  }

  this.message.textContent =
    headlineMessage;

  if (
    this.continueLabel
  ) {
    this.continueLabel.textContent =
      actionMessage;
  }
},
updateProgress() {
  const target =
    this.round2Active
      ? this.secondTarget
      : this.firstTarget;

  const selected =
    Math.min(
      Math.max(
        0,
        this.eligibleCount
      ),
      target
    );

  const percentage =
    target > 0
      ? (selected / target) * 100
      : 0;

  if (
    this.progressFill
  ) {
    this.progressFill.style.width =
      `${percentage}%`;
  }

  if (
    this.progressCount
  ) {
    this.progressCount.textContent =
      `${selected} of ${target} selected`;
  }

  if (
    this.progressTrack
  ) {
    this.progressTrack.setAttribute(
      'data-progress-target',
      String(
        target
      )
    );

    this.progressTrack.setAttribute(
      'data-progress-selected',
      String(
        selected
      )
    );
  }
},
    show() {
      if (
        !this.shouldShowSticky()
      ) {
        this.hideImmediately();
        return;
      }
      clearTimeout(
        this.toastHideTimer
      );
      clearTimeout(
        this.toastHideTransitionTimer
      );
      this.positionToast();
      this.root.hidden =
        false;
      this.toastVisibleUntil =
        Date.now() +
        this.toastDuration;
      document
        .documentElement
        .classList
        .add(
          'sunhauk-b1g2-is-visible'
        );
      requestAnimationFrame(
        () => {
          requestAnimationFrame(
            () => {
              this.root
                .classList
                .add(
                  'is-visible'
                );
            }
          );
        }
      );
      this.toastHideTimer =
        setTimeout(
          () => {
            this.hide();
          },
          this.toastDuration
        );
    },
    hide() {
      clearTimeout(
        this.toastHideTimer
      );
      clearTimeout(
        this.toastHideTransitionTimer
      );
      this.toastVisibleUntil =
        0;
      this.root
        .classList
        .remove(
          'is-visible'
        );
      document
        .documentElement
        .classList
        .remove(
          'sunhauk-b1g2-is-visible'
        );
      this.toastHideTransitionTimer =
        setTimeout(
          () => {
            if (
              !this.root.classList.contains(
                'is-visible'
              )
            ) {
              this.root.hidden =
                true;
            }
          },
          280
        );
    },
    hideImmediately() {
      clearTimeout(
        this.toastHideTimer
      );
      clearTimeout(
        this.toastHideTransitionTimer
      );
      this.toastVisibleUntil =
        0;
      this.root
        .classList
        .remove(
          'is-visible'
        );
      this.root.hidden =
        true;
      document
        .documentElement
        .classList
        .remove(
          'sunhauk-b1g2-is-visible'
        );
    },
    startCompletionFlow(
      cart,
      round
    ) {
      if (
        this.popupOpen ||
        this.completionOpening
      ) {
        return;
      }
      this.completionOpening =
        true;
      this.hideImmediately();
      this.openCompletionPopup(
        cart,
        round
      );
    },
    formatMoney(
  cents,
  currency
) {
  const amount =
    Number(
      cents ||
      0
    ) /
    100;
  const activeCurrency =
    currency ||
    this.cart
      ?.currency ||
    window.Shopify
      ?.currency
      ?.active ||
    null;
  if (
    !activeCurrency
  ) {
    return amount.toLocaleString(
      undefined,
      {
        minimumFractionDigits:
          Number.isInteger(
            amount
          )
            ? 0
            : 2,
        maximumFractionDigits:
          2
      }
    );
  }
  try {
    return (
      new Intl.NumberFormat(
        undefined,
        {
          style:
            'currency',
          currency:
            activeCurrency,
          minimumFractionDigits:
            Number.isInteger(
              amount
            )
              ? 0
              : 2,
          maximumFractionDigits:
            2
        }
      ).format(
        amount
      )
    );
  }
  catch (error) {
    return (
      `${activeCurrency} ${amount.toLocaleString(
        undefined,
        {
          minimumFractionDigits:
            Number.isInteger(
              amount
            )
              ? 0
              : 2,
          maximumFractionDigits:
            2
        }
      )}`
    );
  }
},
   getUnitSubtitle(unit) {
  if (
    !unit
  ) {
    return '';
  }
  const vendor =
    String(
      unit.vendor ||
      unit.item?.vendor ||
      ''
    ).trim();
  if (
    vendor
  ) {
    return vendor;
  }
  return (
    unit.productType ||
    ''
  );
},
    getPopupUnits(pairCount) {
      const units =
        this.displayUnits
          .slice(
            0,
            pairCount
          );
      if (
        units.length <
        pairCount
      ) {
        return units;
      }
      const paid =
        units.filter(
          (unit) =>
            Number(
              unit.finalPrice
            ) >
            0
        );
      const free =
        units.filter(
          (unit) =>
            Number(
              unit.finalPrice
            ) ===
            0
        );
      if (
        pairCount === 3 &&
        paid.length >= 1 &&
        free.length >= 2
      ) {
        return [
          paid[0],
          free[0],
          free[1]
        ];
      }
      if (
        pairCount === 6 &&
        paid.length >= 2 &&
        free.length >= 4
      ) {
        return [
          paid[0],
          free[0],
          free[1],
          paid[1],
          free[2],
          free[3]
        ];
      }
      return units;
    },
    renderPopup(
      cart,
      round
    ) {
      if (
        !this.popup
      ) {
        return false;
      }
      const pairCount =
        round === 2
          ? 6
          : 3;
      const units =
        this.getPopupUnits(
          pairCount
        );
      if (
        units.length <
        pairCount
      ) {
        return false;
      }
      this.popupRound =
        round;
      this.popup
        .classList
        .toggle(
          'is-round-two',
          round === 2
        );
      const currency =
  cart?.currency ||
  this.cart
    ?.currency ||
  window.Shopify
    ?.currency
    ?.active ||
  null;
      const originalTotal =
        units.reduce(
          (
            total,
            unit
          ) => {
            return (
              total +
              Number(
                unit.originalPrice ||
                0
              )
            );
          },
          0
        );
      let dealTotal =
        units.reduce(
          (
            total,
            unit
          ) => {
            return (
              total +
              Number(
                unit.finalPrice ||
                0
              )
            );
          },
          0
        );
      if (
        dealTotal <= 0
      ) {
        const paidFallback =
          round === 2
            ? 2
            : 1;
        dealTotal =
          units
            .slice(
              0,
              paidFallback
            )
            .reduce(
              (
                total,
                unit
              ) => {
                return (
                  total +
                  Number(
                    unit.originalPrice ||
                    0
                  )
                );
              },
              0
            );
      }
      const saving =
        Math.max(
          0,
          originalTotal -
            dealTotal
        );
      const title =
        this.popup.querySelector(
          '[data-b1g2-popup-title]'
        );
      const subtitle =
        this.popup.querySelector(
          '[data-b1g2-popup-subtitle]'
        );
      const originalEl =
        this.popup.querySelector(
          '[data-b1g2-popup-original-total]'
        );
      const totalEl =
        this.popup.querySelector(
          '[data-b1g2-popup-deal-total]'
        );
      const savingEl =
        this.popup.querySelector(
          '[data-b1g2-popup-saving]'
        );
      const checkoutText =
        this.popup.querySelector(
          '[data-b1g2-popup-checkout-text]'
        );
      const doubleCard =
        this.popup.querySelector(
          '[data-b1g2-popup-double-card]'
        );
      const doubleDivider =
        this.popup.querySelector(
          '[data-b1g2-popup-double-divider]'
        );
      if (
        title
      ) {
        title.textContent =
          round === 2
            ? 'YOUR 6 PAIRS ARE LOCKED IN'
            : 'YOUR 3 PAIRS ARE LOCKED IN';
      }
      if (
        subtitle
      ) {
        subtitle.textContent =
          round === 2
            ? 'YOUR DOUBLE DEAL IS APPLIED'
            : 'BUY 1 GET 2 FREE APPLIED TO CART';
      }
      if (
        originalEl
      ) {
        originalEl.textContent =
          this.formatMoney(
            originalTotal,
            currency
          );
      }
      if (
        totalEl
      ) {
        totalEl.textContent =
          this.formatMoney(
            dealTotal,
            currency
          );
      }


     if (
  savingEl
) {

  const savingColumn =
    savingEl.closest(
      '[data-b1g2-popup-saving-column]'
    );


  if (
    saving > 0
  ) {

    savingEl.hidden =
      false;


    if (
      savingColumn
    ) {
      savingColumn.hidden =
        false;
    }


    /*
      Label already says YOU SAVE.

      So the value should only be:
      $158
      £...
      A$...
      etc.
    */
    savingEl.textContent =
      this.formatMoney(
        saving,
        currency
      );

  }

  else {

    savingEl.hidden =
      true;


    if (
      savingColumn
    ) {
      savingColumn.hidden =
        true;
    }

  }

}

this.popupBaseDealTotal =
  dealTotal;
this.popupPairCount =
  pairCount;
this.popupCurrency =
  currency;
if (
  checkoutText
) {
  this.updatePopupCheckoutText(
    cart
  );
}
      if (
        doubleCard
      ) {
        doubleCard.hidden =
          round === 2;
      }
      if (
        doubleDivider
      ) {
        doubleDivider.hidden =
          round === 2;
      }
      this.popupProducts.forEach(
        (
          card,
          index
        ) => {
          const unit =
            units[
              index
            ];
          if (
            !unit ||
            index >= pairCount
          ) {
            card.hidden =
              true;
            return;
          }
          card.hidden =
            false;
          const image =
            card.querySelector(
              '[data-b1g2-popup-product-image]'
            );
          const productTitle =
            card.querySelector(
              '[data-b1g2-popup-product-title]'
            );
          const productSubtitle =
            card.querySelector(
              '[data-b1g2-popup-product-subtitle]'
            );
          const badge =
            card.querySelector(
              '[data-b1g2-popup-product-badge]'
            );
          const isFree =
            Number(
              unit.finalPrice
            ) ===
            0;
          card
            .classList
            .toggle(
              'is-paid',
              !isFree
            );
          card
            .classList
            .toggle(
              'is-free',
              isFree
            );
          if (
            image
          ) {
            image.src =
              unit.image ||
              '';
            image.alt =
              unit.title ||
              '';
          }
          if (
            productTitle
          ) {
            productTitle.textContent =
              unit.title ||
              '';
          }
          if (
            productSubtitle
          ) {
            productSubtitle.textContent =
              this.getUnitSubtitle(
                unit
              );
          }
          if (
            badge
          ) {
            badge.textContent =
              isFree
                ? 'FREE'
                : this.formatMoney(
                    Number(
                      unit.finalPrice ||
                      unit.originalPrice ||
                      0
                    ),
                    currency
                  );
          }
        }
      );
      return true;
    },
getPopupUpsellSelection(cart) {
  const popupUpsellProductIds =
    new Set(
      this.popupUpsellCandidates
        .map(
          (card) =>
            String(
              card.dataset.productId ||
              ''
            )
        )
        .filter(Boolean)
    );
  let hasUpsell =
    false;
  let upsellTotal =
    0;
  (
    cart?.items ||
    []
  ).forEach(
    (item) => {
      const productId =
        String(
          item.product_id ||
          ''
        );
      if (
        !popupUpsellProductIds.has(
          productId
        )
      ) {
        return;
      }
      const quantity =
        Math.max(
          0,
          Number(
            item.quantity ||
            0
          )
        );
      if (
        quantity <= 0
      ) {
        return;
      }
      hasUpsell =
        true;
      const lineTotal =
        Number(
          item.final_line_price ??
          item.line_price ??
          (
            Number(
              item.final_price ??
              item.price ??
              0
            ) *
            quantity
          )
        );
      upsellTotal +=
        Math.max(
          0,
          lineTotal
        );
    }
  );
  return {
    hasUpsell,
    upsellTotal
  };
},


updatePopupCheckoutText(cart) {

  if (
    !this.popup
  ) {
    return;
  }


  const checkoutText =
    this.popup.querySelector(
      '[data-b1g2-popup-checkout-text]'
    );


  if (
    !checkoutText
  ) {
    return;
  }


  /*
    Get only the popup upsells currently
    present in the cart.
  */
  const {
    upsellTotal
  } =
    this.getPopupUpsellSelection(
      cart
    );


  /*
    B1G2 deal price itself.
  */
  const baseDealTotal =
    Number(
      this.popupBaseDealTotal ||
      0
    );


  /*
    Final checkout value displayed in the CTA.

    Example:
    Deal = $89
    Mystery Pair = $25

    CHECKOUT — $114
  */
  const checkoutTotal =
    baseDealTotal +
    Number(
      upsellTotal ||
      0
    );


  const currency =
    cart?.currency ||
    this.popupCurrency ||
    this.cart
      ?.currency ||
    window.Shopify
      ?.currency
      ?.active ||
    null;


  /*
    Always use the exact same language:

    CHECKOUT — $89
    CHECKOUT — $114
    CHECKOUT — £...
    etc.

    Never:
    CHECKOUT — 3 PAIRS FOR...
    CHECKOUT — 6 PAIRS FOR...
  */
  checkoutText.textContent =
    `CHECKOUT — ${this.formatMoney(
      checkoutTotal,
      currency
    )}`;

},



    renderPopupUpsells(cart) {
      if (
        !this.popupUpsellCandidates
          .length
      ) {
        if (
          this.popupUpsellsWrap
        ) {
          this.popupUpsellsWrap.hidden =
            true;
        }
        return;
      }
      if (
        this.popupUpsellsWrap
      ) {
        this.popupUpsellsWrap.hidden =
          false;
      }
      this.popupUpsellCandidates
        .forEach(
          (card) => {
            card.hidden =
              false;
          }
        );
      this.updatePopupUpsellState(
        cart
      );
    },
    updatePopupUpsellState(cart) {
  const cartItems =
    cart?.items ||
    [];
  this.popupUpsellCandidates
    .forEach(
      (card) => {
        const productId =
          String(
            card.dataset.productId ||
            ''
          );
        const addButton =
          card.querySelector(
            '[data-b1g2-popup-upsell-add]'
          );
        const removeButton =
          card.querySelector(
            '[data-b1g2-popup-upsell-remove]'
          );
        if (
          !addButton
        ) {
          return;
        }
        const available =
          addButton
            .dataset
            .available ===
          'true';
        const matchingItems =
          cartItems.filter(
            (item) =>
              String(
                item.product_id ||
                ''
              ) ===
              productId
          );
        const isInCart =
          matchingItems.length >
          0;
        card.classList.toggle(
          'is-added',
          isInCart
        );
        if (
          isInCart
        ) {
          addButton.disabled =
            true;
          addButton.textContent =
            'ADDED';
          if (
            removeButton
          ) {
            removeButton.hidden =
              false;
          }
          return;
        }
        if (
          removeButton
        ) {
          removeButton.hidden =
            true;
        }
        if (
          available
        ) {
          addButton.disabled =
            false;
          addButton.textContent =
            'ADD';
        }
        else {
          addButton.disabled =
            true;
          addButton.textContent =
            'SOLD OUT';
        }
      }
    );
  this.updatePopupCheckoutText(
    cart
  );
},
    async addPopupUpsell(button) {
      if (
        button.disabled
      ) {
        return;
      }
      const variantId =
        Number(
          button.dataset.variantId ||
          0
        );
      if (
        !variantId
      ) {
        return;
      }
      button.disabled =
        true;
      button.textContent =
        'ADDING...';
      try {
        const response =
          await fetch(
            '/cart/add.js',
            {
              method:
                'POST',
              credentials:
                'same-origin',
              headers: {
                'Content-Type':
                  'application/json',
                Accept:
                  'application/json'
              },
              body:
                JSON.stringify({
                  items: [
                    {
                      id:
                        variantId,
                      quantity:
                        1
                    }
                  ]
                })
            }
          );
        if (
          !response.ok
        ) {
          let message =
            'Unable to add product.';
          try {
            const data =
              await response.json();
            message =
              data.description ||
              data.message ||
              message;
          }
          catch (error) {}
          throw new Error(
            message
          );
        }
        const cart =
          await this.readCart();
        this.cart =
          cart;
        this.updatePopupUpsellState(
          cart
        );
        if (
          window.SunhaukCartSync &&
          typeof window
            .SunhaukCartSync
            .refresh ===
          'function'
        ) {
          window
            .SunhaukCartSync
            .refresh({
              source:
                'b1g2-popup-upsell-add'
            });
        }
      }
      catch (error) {
        console.error(
          '[Sunhauk B1G2] popup upsell add failed:',
          error
        );
        button.disabled = false;
         button.textContent = 'ADD';
      }
    },
    async removePopupUpsell(button) {
      const card =
        button.closest(
          '[data-b1g2-popup-upsell]'
        );
      if (
        !card
      ) {
        return;
      }
      const productId =
        String(
          card.dataset.productId ||
          ''
        );
      if (
        !productId
      ) {
        return;
      }
      button.disabled =
        true;
      const oldText =
        button.textContent;
      button.textContent =
        'Removing...';
      try {
        const currentCart =
          await this.readCart();
        const matchingItems =
          (
            currentCart.items ||
            []
          ).filter(
            (item) =>
              String(
                item.product_id ||
                ''
              ) ===
              productId
          );
        if (
          !matchingItems.length
        ) {
          this.cart =
            currentCart;
          this.updatePopupUpsellState(
            currentCart
          );
          return;
        }
        const updates =
          {};
        matchingItems.forEach(
          (item) => {
            if (
              item.key
            ) {
              updates[
                item.key
              ] =
                0;
            }
          }
        );
        const response =
          await fetch(
            '/cart/update.js',
            {
              method:
                'POST',
              credentials:
                'same-origin',
              headers: {
                'Content-Type':
                  'application/json',
                Accept:
                  'application/json'
              },
              body:
                JSON.stringify({
                  updates:
                    updates
                })
            }
          );
        if (
          !response.ok
        ) {
          throw new Error(
            'Unable to remove upsell.'
          );
        }
        const cart =
          await response.json();
        this.cart =
          cart;
        this.updatePopupUpsellState(
          cart
        );
        if (
          window.SunhaukCartSync &&
          typeof window
            .SunhaukCartSync
            .refresh ===
          'function'
        ) {
          window
            .SunhaukCartSync
            .refresh({
              source:
                'b1g2-popup-upsell-remove'
            });
        }
      }
      catch (error) {
        console.error(
          '[Sunhauk B1G2] popup upsell remove failed:',
          error
        );
        button.disabled =
          false;
        button.textContent =
          oldText ||
          'Remove';
      }
      finally {
        button.disabled =
          false;
        if (
          button.textContent ===
          'Removing...'
        ) {
          button.textContent =
            'Remove';
        }
      }
    },
    openCompletionPopup(
      cart,
      round
    ) {
      if (
        !this.popup ||
        this.popupOpen
      ) {
        this.completionOpening =
          false;
        return;
      }
      this.cart =
        cart;
      const rendered =
        this.renderPopup(
          cart,
          round
        );
      if (
        !rendered
      ) {
        this.completionOpening =
          false;
        return;
      }
      this.renderPopupUpsells(
        cart
      );
      this.lastFocusedElement =
        document.activeElement;
      clearTimeout(
        this.popupHideTimer
      );
      this.popup.hidden =
        false;
      this.popup.setAttribute(
        'aria-hidden',
        'false'
      );
      document
        .documentElement
        .classList
        .add(
          'sunhauk-b1g2-popup-open'
        );
      this.popupOpen =
        true;
      this.popupRound =
        round;
      this.completionOpening =
        false;
      requestAnimationFrame(
        () => {
          this.popup
            .classList
            .add(
              'is-open'
            );
        }
      );
    },
    closePopup(
      restoreFocus = true
    ) {
      if (
        !this.popup
      ) {
        return;
      }
      clearTimeout(
        this.popupHideTimer
      );
      this.popup
        .classList
        .remove(
          'is-open'
        );
      this.popup.setAttribute(
        'aria-hidden',
        'true'
      );
      document
        .documentElement
        .classList
        .remove(
          'sunhauk-b1g2-popup-open'
        );
      this.popupOpen =
        false;
      this.completionOpening =
        false;
      this.popupHideTimer =
        setTimeout(
          () => {
            this.popup.hidden =
              true;
            if (
              restoreFocus &&
              this.lastFocusedElement &&
              typeof this
                .lastFocusedElement
                .focus ===
              'function'
            ) {
              try {
                this.lastFocusedElement
                  .focus({
                    preventScroll:
                      true
                  });
              }
              catch (error) {}
            }
          },
          220
        );
    }
  };
  window.SunhaukB1G2 =
    B1G2;
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        B1G2.init();
      },
      {
        once:
          true
      }
    );
  }
  else {
    B1G2.init();
  }
})();
